import { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'
import { InfoButton, LinkButton } from 'components/buttons'
import { CONFIG } from 'shared/constants'
import { SelectableOptions } from 'baby-ui/compounds/SelectableOptions/SelectableOptions'
import Slide from '../slide/slide'

export const SIZE_KEYS = {
  CLOTHING: 'clothing_size',
  SHOE: 'shoe_size',
}

type SizeKey = (typeof SIZE_KEYS)[keyof typeof SIZE_KEYS]

export interface ClothingSizesProps {
  nextPath: string
  onSubmit: (data: any) => void
  initialSelectedOptions?: {
    [key in SizeKey]?: any[]
  }
}

export const ClothingSizes = ({
  nextPath,
  onSubmit,
  initialSelectedOptions = {},
}: ClothingSizesProps) => {
  const navigate = useNavigate()
  const [selectedOptions, setSelectedOptions] = useState({
    [SIZE_KEYS.CLOTHING]: initialSelectedOptions[SIZE_KEYS.CLOTHING] || [],
    [SIZE_KEYS.SHOE]: initialSelectedOptions[SIZE_KEYS.SHOE] || [],
  })

  const handleSelect = useCallback((key: string, data: any) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [key]: data,
    }))
  }, [])

  const navigateAndSubmit = (data: any) => {
    navigate(nextPath)
    onSubmit(data)
  }

  const handleNext = () => navigateAndSubmit(selectedOptions)

  const handleSkip = () =>
    navigateAndSubmit({
      [SIZE_KEYS.CLOTHING]: [],
      [SIZE_KEYS.SHOE]: [],
    })

  const hasMadeSelections = () =>
    selectedOptions[SIZE_KEYS.CLOTHING].length > 0 ||
    selectedOptions[SIZE_KEYS.SHOE].length > 0

  return (
    <Slide title="What size do they wear?">
      <div style={{ maxWidth: '435px' }}>
        <div className="h4 text-bold text-brand-info text-center">Clothing</div>
        <SelectableOptions
          options={CONFIG?.registryAttributeDataOptions?.clothingSizeOptions}
          selectedOptions={selectedOptions[SIZE_KEYS.CLOTHING]}
          onSelect={(data: any) => handleSelect(SIZE_KEYS.CLOTHING, data)}
        />
        <div className="h4 text-bold text-brand-info text-center">
          Shoe Size
        </div>
        <SelectableOptions
          options={CONFIG?.registryAttributeDataOptions?.shoeSizeOptions}
          selectedOptions={selectedOptions[SIZE_KEYS.SHOE]}
          onSelect={(data: any) => handleSelect(SIZE_KEYS.SHOE, data)}
        />
      </div>
      <InfoButton
        pill
        className="mtl"
        disabled={!hasMadeSelections()}
        style={{ minWidth: 230 }}
        onClick={handleNext}
      >
        Next
      </InfoButton>
      <LinkButton onClick={handleSkip}>Skip</LinkButton>
    </Slide>
  )
}
